import BaseAbility from 'umg-ember-backend/abilities/base';
import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

export default class ExternalReferenceAbility extends BaseAbility {
  get permissions() {
    return this.permission.for(getRecordType(this.parentModel));
  }
}
